import React, { FC } from 'react'
import text from 'styles/utility/text.module.scss'
import { ScheduleType } from 'types/schedule'
import equal from 'fast-deep-equal'
import useDaysOfWeekName from 'hooks/bread/useDaysOfWeekName'

type Props = {
  schedule: ScheduleType
  isSameHolidays: boolean
}

const SettingsScheduleHolidays: FC<Props> = React.memo(
  (props) => {
    const { isSameHolidays, schedule } = props

    const daysOfWeekName = useDaysOfWeekName(schedule)

    if (isSameHolidays) {
      return <p className={`${text.font_small} ${text.font_bold}`}>{daysOfWeekName}</p>
    } else {
      return <p className={`${text.color_caution} ${text.font_small} ${text.font_bold}`}>{daysOfWeekName}</p>
    }
  },
  (prev, next) => equal(prev, next)
)

export default SettingsScheduleHolidays
